import OutlineButton from '@components/Buttons/Outline';
import SpeakerSelection from '@components/SpeakerSelection';
import { css } from '@emotion/react';
import { useTestSound } from '@hooks/device/useTestSound';
import { useAudioOutputs } from '@providers/DevicesProvider';
import { currentSpeackerCheck } from '@stores/atoms/device';
import { useAtom } from 'jotai';
import { type FC } from 'react';
import {
  Container,
  DeviceControlArea,
  DeviceName,
  DeviceSplitArea,
  DeviceSplitLeft,
  DeviceSplitRight,
  DeviceStatusArea,
  SelectorContainer,
} from './style';

const Speaker: FC = () => {
  const { devices, selectedDevice } = useAudioOutputs();
  const { playTestSound } = useTestSound();
  const [checkSpeaker, setCheckSpeaker] = useAtom(currentSpeackerCheck);

  const isCheckSpeacker = checkSpeaker !== null;

  const handleClickYes = () => {
    setCheckSpeaker(true);
  };

  const handleClickNo = () => {
    setCheckSpeaker(false);
  };

  const handleClickTest = () => {
    const device = devices.find(({ deviceId }) => deviceId === selectedDevice);
    playTestSound(device);
  };

  const fadeOut = css({
    transition: `all 0.5s ease`,
    opacity: isCheckSpeacker ? 0 : 1,
    visibility: isCheckSpeacker ? 'hidden' : 'visible',
    position: isCheckSpeacker ? 'absolute' : 'static',
  });

  const fadeIn = css({
    transition: `all 1s ease 0.5s`,
    opacity: isCheckSpeacker ? 1 : 0,
    visibility: isCheckSpeacker ? 'visible' : 'hidden',
    position: isCheckSpeacker ? 'static' : 'absolute',
  });

  return (
    <Container>
      <DeviceStatusArea>
        <DeviceName>
          스피커(테스트 소리 재생 중입니다. 소리가 잘 들리면 "예"를
          선택해주세요)
        </DeviceName>
      </DeviceStatusArea>
      <DeviceControlArea>
        <DeviceSplitArea>
          <DeviceSplitLeft>
            <SelectorContainer
              css={css`
                transition: all 2s ease 1s;
                width: ${isCheckSpeacker ? '100%' : 'calc(100% - 124px)'};
              `}
            >
              <SpeakerSelection />
            </SelectorContainer>

            <OutlineButton
              onClick={handleClickTest}
              css={css`
                width: 120px;
                right: 0;
                ${fadeOut}
              `}
            >
              테스트
            </OutlineButton>
          </DeviceSplitLeft>
          <DeviceSplitRight>
            <OutlineButton
              onClick={handleClickYes}
              css={css`
                width: calc(100% / 2 - 2px);
                left: 0;
                ${fadeOut}
              `}
            >
              예
            </OutlineButton>
            <OutlineButton
              onClick={handleClickNo}
              css={css`
                width: calc(100% / 2 - 2px);
                right: 0;
                ${fadeOut}
              `}
            >
              아니오
            </OutlineButton>
            <OutlineButton
              css={css`
                ${fadeIn}
              `}
            >
              {checkSpeaker ? '완료' : '실패'}
            </OutlineButton>
          </DeviceSplitRight>
        </DeviceSplitArea>
      </DeviceControlArea>
    </Container>
  );
};

export default Speaker;
